export default {"src":"/_next/static/media/coldplunge.940ab095.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};